module.exports = __webpack_public_path__ + "static/1337844041.0e1ca45a.jpg";